import React from 'react'
import { Container, Row } from 'reactstrap'


import MedicineHistory from './MedicineHistory'


export default function Approved() {
    return (
        <>
            <Container className='manager-card' fluid>
                <Row>
                  
               <MedicineHistory/>
                </Row>
            </Container>
        </>
    )
}